import React from "react";
import Layout from "layouts";
import BakeDatesComponent from "./BakeDatesComponent";

export default function BakeDates() {
  return (
    <Layout breadCrumb={[{ label: "Bake Dates", to: "#" }]}>
      <BakeDatesComponent />
    </Layout>
  );
}
